module.exports = __webpack_public_path__ + "static/media/logo-white.9ac96b27.png";